// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled, { keyframes } from 'styled-components';
import MenuList from './MenuList';
import { MiniBar } from './TopNav';

const Col = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
const Row = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`
const Wrapper = styled.div`
    position: fixed;
    top: 0;
    display: flex;
    justify-content: center;
    background: ${({ theme }) => theme.secondary};
    width: 100%;
    z-index: 50;
    transform: translateY(${({showMini}) => showMini ? '0%' : '-101%'});
    transition: all 0.5s;
`;

const MiniNav = ({ showMini, children, ...props }) => {
    return (
        <Wrapper showMini={showMini}>
            <Col>
                <Row>
                    <MenuList />
                </Row>
                <MiniBar />
            </Col>
        </Wrapper>
    );
}

export default MiniNav;